module.exports = __webpack_public_path__ + "common/images/polaris@2x.png";


//////////////////
// WEBPACK FOOTER
// ./Common/images/polaris@2x.png
// module id = 10
// module chunks = 0 1 2 3 4 5 6 7